<div id="user-settings-events" class="settings-panel" [class.mobile]="isMobile">
  <div class="head">
    <span class="material-icons go-back" (click)="goBack.emit()"> arrow_back </span>
    <div class="description">
      <div class="title">{{ panelData?.name }}</div>
      <div class="subtitle">{{ panelData?.description }}</div>
    </div>
    <span class="material-icons close" (click)="goBack.emit()"> close </span>
  </div>
  <div class="sub-head" *ngIf="isMobile">
    {{ panelData?.description }}
  </div>
  <form [formGroup]="settingsForm" (submit)="submitChanges()">
    <div class="body">
      <!-- TODO Move the condition of start call capability on first toggle when a new toggle is added to event sub-panel -->
      <div class="action-bars">
        <div class="bar">
          <app-user-settings-permissions-toggle
            [formGroup]="form"
            [options]="{
              setting: 'enableAutoStartCall',
              titleText: ('Automatically start call in a Space during an event' | translate),
              activeText:
                ('Calls will be started automatically in a Space whenever an event is active'
                | translate),
              inactiveText:
                ('Calls will not be started automatically in a Space whenever an event is active'
                | translate),
              disableOptions: {
                disabled: (isStartCallEnabled$ | async) === false
              }
            }"
          >
          </app-user-settings-permissions-toggle>
        </div>
      </div>
      <div class="attendance-section">
        <div class="attendance-title">{{ 'Attendance' | translate }}</div>
        <div class="attendance-table">
          <div class="attendance-row attendance-row--header">
            <div class="attendance-cell">{{ 'Threshold' | translate }}</div>
            <div class="attendance-cell">{{ 'Organizer' | translate }}</div>
            <div class="attendance-cell">{{ 'Attendee' | translate }}</div>
          </div>

          <div class="attendance-row">
            <div class="attendance-cell attendance-cell--label">{{ 'Late after' | translate }}</div>
            <ng-container
              *ngTemplateOutlet="
                attendanceThresholdCell;
                context: {
                  status: AttendanceStatus.LATE,
                  role: AttendanceUserRole.ORGANIZER,
                  options: attendanceMinuteOptions
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                attendanceThresholdCell;
                context: {
                  status: AttendanceStatus.LATE,
                  role: AttendanceUserRole.ATTENDEE,
                  options: attendanceMinuteOptions
                }
              "
            ></ng-container>
          </div>

          <div class="attendance-row">
            <div class="attendance-cell attendance-cell--label">
              {{ 'Absent after' | translate }}
            </div>
            <ng-container
              *ngTemplateOutlet="
                attendanceThresholdCell;
                context: {
                  status: AttendanceStatus.ABSENT,
                  role: AttendanceUserRole.ORGANIZER,
                  options: absentMinuteOptions,
                  defaultLabel: absentMinuteOptions[0].label
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                attendanceThresholdCell;
                context: {
                  status: AttendanceStatus.ABSENT,
                  role: AttendanceUserRole.ATTENDEE,
                  options: absentMinuteOptions,
                  defaultLabel: absentMinuteOptions[0].label
                }
              "
            ></ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="foot" [class.show]="formChanged$ | async">
      <app-pencil-button
        class="pencil-button primary btn-ok"
        [buttonType]="'submit'"
        [class.disabled]="form.invalid"
        [disabled]="form.invalid"
      >
        <span *ngIf="!isLoading" class="material-icons">check</span>
        <mat-spinner *ngIf="isLoading" [diameter]="24"></mat-spinner>
        <span>{{ 'Update' | translate }}</span>
      </app-pencil-button>
      <app-pencil-button
        class="pencil-button light btn-cancel"
        [buttonType]="'button'"
        (clickEvent)="cancelChanges()"
        type="button"
        icon="close"
        [iconConfig]="{ type: 'material-icon' }"
        [label]="'Cancel' | translate"
      >
      </app-pencil-button>
    </div>
  </form>
</div>

<ng-template
  #attendanceThresholdCell
  let-status="status"
  let-role="role"
  let-options="options"
  let-defaultLabel="defaultLabel"
>
  <div class="attendance-cell">
    <app-pencil-button
      class="attendance-dropdown"
      [matMenuTriggerFor]="attendanceThresholdMenu"
      buttonType="button"
    >
      <span>
        <ng-container
          *ngIf="
            settingsForm?.get('attendanceThresholds')?.value
              | lookupMulti: { status: status, role: role } as rule;
            else defaultThreshold
          "
        >
          {{ '{{minutes}} minutes' | translate: { minutes: rule.minutes } }}
        </ng-container>
        <ng-template #defaultThreshold>{{ defaultLabel }}</ng-template>
      </span>
      <span class="material-icons">expand_more</span>
    </app-pencil-button>
    <mat-menu
      #attendanceThresholdMenu="matMenu"
      class="pencil-mat-menu attendance-menu light-scheme"
    >
      <app-pencil-menu-item
        *ngFor="let opt of options"
        [label]="opt.label"
        (clickEvent)="setThreshold(status, role, opt.minutes)"
      ></app-pencil-menu-item>
    </mat-menu>
  </div>
</ng-template>
